import { isDevelopmentEnvironment, mapString } from "utils";
import appConfig from "config.json";

const trackAnalytics = !isDevelopmentEnvironment();

const getAnalyticsFramework = () => {
	return (
		window?.WDPRO &&
		window?.WDPRO.Analytics &&
		window?.WDPRO.Analytics.Framework
	);
};

const checkInitialization = (ref) => {
	return ref && ref.analyticsModel.length;
};

const trackLink = (model, customEvent) => {
	if (trackAnalytics) {
		const ref = getAnalyticsFramework();
		if (checkInitialization(ref)) {
			const updatedModel = Object.assign(model, { trackingType: "customLink" });
			if (customEvent) {
				ref.trackElement(customEvent, updatedModel);
			} else {
				ref.trackElement(updatedModel);
			}
		} else {
			console.error(
				"Something is wrong with Analytics Framework. Check that is correctly configured."
			);
		}
	}
};

const sendAnalyticsEvent = (
	brand,
	analyticsEventKey,
	swid = null,
	eventPayload = {}
) => {
	const analyticsEvent = appConfig.analyticsEvents[analyticsEventKey];
	if (analyticsEvent) {
		const eventData = { ...eventPayload };
		eventData.site = brand.toUpperCase();
		if (swid) {
			eventData.customerId = swid;
		}
		if (window) {
			(window.DisneyDataLayer || (window.DisneyDataLayer = [])).push([
				"trackElement",
				{
					linkId: mapString(analyticsEvent.linkId, brand),
					events: analyticsEvent.events,
					...eventData,
				},
			]);
		}
	}
};

export { trackLink, sendAnalyticsEvent };
